class Clustering {
    constructor(map) {
        this.map = map;

        this.addLayers();
        this.splitOnClick();
        this.setCursorIcon();
    }

    // Add cluster layers
    addLayers() {
        // Clusters
        if (!this.map.getLayer('clusters')) {
            this.map.addLayer({
                id: 'clusters',
                type: 'circle',
                source: 'locations',
                filter: ['has', 'point_count'],
                paint: {
                    'circle-color': [
                        'step',
                        ['get', 'point_count'],
                        '#019DDA',
                        5, '#CED700',
                        10, '#DF418C'
                    ],
                    'circle-radius': [
                        'step',
                        ['get', 'point_count'],
                        15,
                        10, 20,
                        30, 25
                    ]
                }
            });
        }

        // Cluster labels (count)
        if (!this.map.getLayer('cluster-count')) {
            this.map.addLayer({
                id: 'cluster-count',
                type: 'symbol',
                source: 'locations',
                filter: ['has', 'point_count'],
                layout: {
                    'text-field': '{point_count_abbreviated}',
                    'text-font': ['open_sans_bold'],
                    'text-size': 12,
                },
                paint: {
                    'text-color': '#ffffff'
                }
            });
        }

        // Unclustered points
        if (!this.map.getLayer('unclustered-point')) {
            this.map.addLayer({
                id: 'unclustered-point',
                type: 'symbol',
                source: 'locations',
                filter: ['!', ['has', 'point_count']],
                // Active location ID gets a different marker
                layout: {
                    'icon-image': [
                        'match',
                        ['get', 'id'],
                        window.activeLocationId ? window.activeLocationId : '',
                        'map-marker-active',
                        'map-marker'
                    ],
                    'icon-size': 0.25,
                    'icon-anchor': 'bottom'
                }
            });
        }
    }

    // Split clusters (and zoom) when clicking on them
    splitOnClick() {
        this.map.on('click', 'clusters', (e) => {
            const features = this.map.queryRenderedFeatures(e.point, {
                layers: ['clusters']
            });
            const clusterId = features[0].properties.cluster_id;
            const source = this.map.getSource('locations');

            source.getClusterExpansionZoom(clusterId).then((zoom) => {
                this.map.easeTo({
                    center: features[0].geometry.coordinates,
                    zoom,
                    duration: 1000
                });
            }).catch(err => console.error(err));
        });
    }

    // Set mouse cursor icon
    setCursorIcon() {
        this.map.on('mouseenter', 'clusters', () => {
            this.map.getCanvas().style.cursor = 'pointer';
        });
        this.map.on('mouseleave', 'clusters', () => {
            this.map.getCanvas().style.cursor = '';
        });
    }
}

export default Clustering;
